<template>
  <div>
    <CCardBody class="py-0 pl-2 pr-0">
      <table class="table mb-0">
        <tbody>
          <div
            class="custom-width-total"
            v-for="(r, index) in servicios.filter(
              serv => serv.payload.pertenece_id == servicioPadre
            )"
            :key="index"
          >
            <tr class="custom-width-total">
              <td
                @click="toggleSubServicios(index)"
                class="custom-width"
                :class="
                  `${
                    servicios.filter(s => s.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
              >
                <span>
                  <CIcon
                    v-if="
                      servicios.filter(s => s.payload.pertenece_id == r.id)
                        .length > 0
                    "
                    name="cil-chevron-circle-down-alt"
                  />
                </span>
                {{ r.payload.nombre }}
              </td>
              <td
                @click="toggleSubServicios(index)"
                class="custom-width"
                :class="
                  `${
                    servicios.filter(s => s.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
              >
                {{
                  r.payload.pertenece_id == 0
                    ? ""
                    : getCategoria(r.payload.pertenece_id)
                }}
              </td>

              <td class="custom-width5">
                <router-link
                  :to="{ name: 'EditarServicio', params: { id: r.id } }"
                >
                  <CButton color="success" square size="sm">Editar</CButton>
                </router-link>
              </td>
              <td class="custom-width5">
                <CButton
                  color="danger"
                  :disabled="
                    servicios.filter(p => p.payload.pertenece_id == r.id)
                      .length > 0
                      ? true
                      : false
                  "
                  square
                  size="sm"
                  @click="toggleCancel(index, r)"
                  >Borrar</CButton
                >
              </td>
            </tr>
            <tr
              v-if="
                servicios.filter(s => s.payload.pertenece_id == r.id).length > 0
              "
            >
              <td class="py-0 pl-2 pr-0" colspan="4">
                <CCollapse
                  :show="subDetails.includes(index)"
                  class="m-0 custom-width-total"
                >
                  <table-collapse-services
                    @click-cancel="toggleCancel"
                    :servicioPadre="r.id"
                    :servicios="servicios"
                  ></table-collapse-services>
                </CCollapse>
              </td>
            </tr>
          </div>
        </tbody>
      </table>
    </CCardBody>
  </div>
</template>

<script>
export default {
  name: "TableCollapseServices",

  props: {
    servicios: {
      type: Array
    },
    servicioPadre: {
      type: Number
    }
  },

  data() {
    return {
      details: [],
      subDetails: [],
      itemModal: { id: "", name: "", index: "" }
    };
  },

  components: {
    TableCollapseServices: () => import("./TableCollapseServices.vue")
  },

  methods: {
    getCategoria(pertenece_id) {
      const servicioActual = this.servicios.filter(
        servicio => servicio.id == pertenece_id
      );
      try {
        return servicioActual[0].payload.nombre;
      } catch (error) {
        // console.log(pertenece_id);
        // console.log(this.servicios);
        return "Sin categoría";
      }
    },
    toggleCancel(index, item) {
      this.$emit("click-cancel", index, item);
    },

    toggleSubServicios(index) {
      const positionSub = this.subDetails.indexOf(index);
      positionSub !== -1
        ? this.subDetails.splice(positionSub, 1)
        : this.subDetails.push(index);
    }
  }
};
</script>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 50%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100% !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
